/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircleRectangle = createReactComponent("outline", "circle-rectangle", "IconCircleRectangle", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M7 10h10v4h-10z", "key": "svg-1" }]]);

export { IconCircleRectangle as default };
//# sourceMappingURL=IconCircleRectangle.mjs.map
